import Vue from "vue";
import 'table2excel';
var Table2Excel = window.Table2Excel;
export default Vue.extend({
    name: "online-resume",
    data: function () {
        return {
            resumeData: {
                name: null,
                sex: null,
                birthDay: null,
                place: null,
                school: null,
                time: null,
                degree: null,
                years: null,
                tel: null,
                otherTel: null,
                email: null,
                qq: null,
                job: null,
                skill: null,
                history: [
                    { durTime: null, com: null, job: null, contact: null },
                    { durTime: null, com: null, job: null, contact: null },
                    { durTime: null, com: null, job: null, contact: null },
                    { durTime: null, com: null, job: null, contact: null },
                    { durTime: null, com: null, job: null, contact: null },
                ],
                remark: null,
            },
            flg: true,
        };
    },
    mounted: function () {
    },
    methods: {
        tableExport: function () {
            var _this = this;
            this.flg = false;
            this.$nextTick(function () {
                var date = new Date();
                var file = '简历' + date.getFullYear() + date.getMonth() + date.getDate();
                var table2excel = new Table2Excel({ defaultFileName: file });
                table2excel.export(document.getElementById('whTable'));
                setTimeout(function () {
                    _this.flg = true;
                }, 300);
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/about/online-resume.vue
// module id = null
// module chunks = 